<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="1056.982" height="1079.35" viewBox="0 0 1056.982 1079.35">
  <defs>
    <filter id="Pfad_229" x="32.693" y="556.207" width="100%"  filterUnits="userSpaceOnUse">
      <feOffset dx="-6" dy="13" input="SourceAlpha"/>
      <feGaussianBlur stdDeviation="19" result="blur"/>
      <feFlood flood-opacity="0.161"/>
      <feComposite operator="in" in2="blur"/>
      <feComposite in="SourceGraphic"/>
    </filter>
    <filter id="Pfad_230" x="377.466" y="314.273" width="641" height="765.077" filterUnits="userSpaceOnUse">
      <feOffset dy="16" input="SourceAlpha"/>
      <feGaussianBlur stdDeviation="21.5" result="blur-2"/>
      <feFlood flood-opacity="0.161"/>
      <feComposite operator="in" in2="blur-2"/>
      <feComposite in="SourceGraphic"/>
    </filter>
    <filter id="Dach" x="0" y="0" width="1056.982" height="972.627" filterUnits="userSpaceOnUse">
      <feOffset dx="2" dy="25" input="SourceAlpha"/>
      <feGaussianBlur stdDeviation="16" result="blur-3"/>
      <feFlood flood-opacity="0.161"/>
      <feComposite operator="in" in2="blur-3"/>
      <feComposite in="SourceGraphic"/>
    </filter>
  </defs>
  <g id="Pultdach" class="cls-1" transform="translate(-508.034 -5.15)">
    <g id="Wände">
      <g class="cls-9" transform="matrix(1, 0, 0, 1, 508.03, 5.15)">
        <path id="Pfad_229-2" data-name="Pfad 229" class="cls-2" d="M29.727-86.643,376.037,91.711V311.654L29.727,10.932Z" transform="translate(65.97 686.85)"/>
      </g>
      <g class="cls-8" transform="matrix(1, 0, 0, 1, 508.03, 5.15)">
        <path id="Pfad_230-2" data-name="Pfad 230" class="cls-3" d="M0,398.582,512-19.077V216.11L0,617Z" transform="translate(441.97 381.85)"/>
      </g>
    </g>
    <g class="cls-7" transform="matrix(1, 0, 0, 1, 508.03, 5.15)">
      <g id="Dach-2" data-name="Dach" class="cls-4" transform="matrix(0.79, -0.62, 0.62, 0.79, 190.78, 472.43)">
        <path class="cls-5" d="M 8.423391342163086 402.3481750488281 L -177.4780120849609 -3.145223140716553 L 542.0546875 -6.499082565307617 L 720.2722778320313 397.4385375976563 L 8.423391342163086 402.3481750488281 Z"/>
        <path class="cls-6" d="M 541.7294921875 -5.9976806640625 L -176.700439453125 -2.648834228515625 L 8.7431640625 401.8458251953125 L 719.5074462890625 396.9437866210938 L 541.7294921875 -5.9976806640625 M 542.3798828125 -7.000732421875 L 721.0369873046875 397.9332885742188 L 8.10357666015625 402.8502807617188 L -178.2556762695313 -3.6416015625 L 542.3798828125 -7.000732421875 Z"/>
      </g>
    </g>
  </g>
</svg>

</template>
<script>
export default {
    name: "Pultdach"
}
</script>

<style scoped>
 .cls-1 {
        isolation: isolate;
      }

      .cls-2 {
        fill: #fff;
      }

      .cls-3 {
        fill: #f5f5f5;
      }

      .cls-4, .cls-6 {
        fill: #006fba;
      }

      .cls-5, .cls-6 {
        stroke: none;
      }

      .cls-7 {
        filter: url(#Dach);
      }

      .cls-8 {
        filter: url(#Pfad_230);
      }

      .cls-9 {
        filter: url(#Pfad_229);
      }
</style>